<template>
  <v-container fluid class="pa-0">
    <v-row
      class="mx-1 pa-0 text-center justify-center hover-translate hover-box-container"
      :style="'min-height: 570px'">
      <!-- :style="'height:' + computedPageHeight + 'px'"> -->
      <v-col>
        <v-row class="justify-center">
          <v-col
            v-for="(item,index) in services"
            :key="index"
            cols="12"
            sm="12"
            md="6"
            lg="4"
            class="d-flex hover-primary white--text bg-coloring-img parallax"
            style="">
            <v-img
              :src="item.img">
              <v-card
                flat
                tile
                dark
                :color="item.color"
                class="w-100 h-100 d-flex align-center ">
                <v-card-text
                  class="ma-8 pa-xs-4 pa-md-12">
                  <v-row>
                    <v-col class="pb-0">
                      <v-icon size="88">
                        {{ item.icon }}
                      </v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pb-2 fontsize-2rem-clamp text-center white--text min-height-100" style="align-content:flex-end; display:grid;">
                      {{ $t(item.title) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pt-0 subtitle text-center white--text" style="align-content:flex-start; display:grid;">
                      {{ $t(item.subtitle) }}
                    </v-col>
                    <v-col cols="12" class="pt-4 pb-8 min-height-150">
                      {{ $t(item.text) }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0 pb-8">
                      <v-btn
                        tile
                        outlined
                        @click="loadPage(item.route)">
                        {{ $t('common.more') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Services',
    extends: DataComponentBase,

    data: () => ({
      services: [
        {
          icon: "mdi-xml",
          color: "#1256a9D9",
          title: "service.itSolutions.title",
          subtitle: "service.itSolutions.01.text",
          text: "service.itSolutions.02.text",
          route: "ItSolutions",
          class: "itservices",
          img: require("@/assets/img/home-services-01.webp"),
        },
        {
          icon: "mdi-lightning-bolt-circle",
          color: "#005952D9",
          title: "service.ernergyManagement.title",
          subtitle: "service.ernergyManagement.01.text",
          text: "service.ernergyManagement.02.text",
          route: "EnergyManagement",
          class: "energymanagement",
          img: require("@/assets/img/home-services-02.webp"),
        },
        {
          icon: "mdi-memory",
          color: "#607D8BD9",
          title: "service.hardware.title",
          subtitle: "service.hardware.01.text",
          text: "service.hardware.02.text",
          route: "Hardware",
          class: "hardware",
          img: require("@/assets/img/home-services-03.webp"),
        },
      ],

    }),
  }
</script>
